<template>
  <div class="carousel" :style="{ height: this.parentHeight + 'px' }">
    <div :style="{ transform: 'translateY(-' + transform + 'px)' }">
      <template v-for="(item, index) in list">
        <div :key="index">
          <slot :item="item" :childHeight="childHeight"></slot>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  props: {
    initList: {
      type: Array,
      default: () => [],
    },
    childHeight: {
      type: Number,
      default: 0,
    },
    parentHeight: {
      type: Number,
      default: 0,
    },
    speed: {
      type: Number,
      default: 0.5,
    },
  },
  data() {
    return {
      list: [],
      transform: 0,
      interval: null,
    };
  },
  computed: {
    fold() {
      return Math.ceil(this.parentHeight / this.childHeight);
    },
  },
  watch: {
    initList() {
      this.init();
    },
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    init() {
      clearInterval(this.interval);
      let list = this._.cloneDeep(this.initList);
      list.push(...list.slice(0, this.fold));
      this.list = list;
      this.transform = 0;
      this.interval = setInterval(() => {
        this.transform += this.speed;
        if (
          this.transform >=
          (this.list.length - this.fold) * this.childHeight
        ) {
          this.transform = 0;
        }
      }, 16);
    },
  },
};
</script>


<style scoped lang="scss">
.carousel {
}
</style>

